
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'ChipDistributionAnalysis',
  props: {
    jzdData: {
      type: Object as PropType<any>,
      default: () => ({})
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  setup() {
    const formatPrice = (price: number | null | undefined) => {
      if (price === null || price === undefined) return '-'
      return price.toFixed(2) + '元'
    }

    const valueColorClass = (val: number | null | undefined) => {
      if (!val) return ''
      return val > 0 ? 'red-text' : (val < 0 ? 'green-text' : '')
    }

    const formatRate = (rate: number | null | undefined) => {
      if (rate === null || rate === undefined) return '-'
      return (rate * 100).toFixed(2) + '%'
    }

    const formatCost = (jzd: any) => {
      if (!jzd || jzd.costL == null || jzd.costH == null) return '-'
      return `${jzd.costL.toFixed(2)}-${jzd.costH.toFixed(2)}`
    }

    const formatRateValue = (val: number | null | undefined) => {
      if (val === null || val === undefined) return '-'
      return val.toFixed(2) + '%'
    }

    const jzdColor = (colorCode: number) => {
      if (colorCode === 1) return 'red-text'
      if (colorCode === 2) return 'orange-text'
      if (colorCode === 3) return 'blue-text'
      return ''
    }

    const jzdDiffColor = (diff: number | null | undefined) => {
      if (!diff) return ''
      return diff > 0 ? 'red-text' : (diff < 0 ? 'green-text' : '')
    }

    const formatJzdDiff = (diff: number | null | undefined) => {
      if (diff === null || diff === undefined) return '-'
      if (diff === 0) return '0.00%'
      const prefix = diff > 0 ? '↑' : '↓'
      const sign = diff > 0 ? '+' : '-'
      return sign + Math.abs(diff).toFixed(2) + '%' + prefix
    }

    return {
      formatPrice,
      valueColorClass,
      formatRate,
      formatCost,
      formatRateValue,
      jzdColor,
      jzdDiffColor,
      formatJzdDiff
    }
  }
})
